module.exports = __webpack_public_path__ + "static/media/prom-opecs-logo.18e24c5a.png";